import React, { useState, useEffect } from 'react';
import apiService from '../api/apiService';
import './TablePages.css';

const Drivers: React.FC = () => {
  const [list, setList] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const { data } = await apiService.get('/admin/drivers');
      setList(data);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  const handleBlock = async (id: number) => {
    try {
      await apiService.put(`/admin/drivers/${id}/block`);
      load();
    } catch (e: any) {
      alert(e.response?.data?.detail || 'Failed');
    }
  };

  const handleUnblock = async (id: number) => {
    try {
      await apiService.put(`/admin/drivers/${id}/unblock`);
      load();
    } catch (e: any) {
      alert(e.response?.data?.detail || 'Failed');
    }
  };

  const formatDate = (s: string) => (s ? new Date(s).toLocaleString() : '-');

  if (loading) return <p>Loading...</p>;

  return (
    <div className="table-page">
      <div className="table-toolbar">
        <div className="table-toolbar-right">
          <button type="button" onClick={load} className="btn-primary">Refresh</button>
        </div>
      </div>
      <div className="table-wrapper">
        <table className="data-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Mobile</th>
              <th>Vehicle</th>
              <th>Type</th>
              <th>Distributor</th>
              <th>Available</th>
              <th>Status</th>
              <th>Actions</th>
              <th>Created</th>
            </tr>
          </thead>
          <tbody>
            {list.map((row) => (
              <tr key={row.id}>
                <td>{row.driver_name}</td>
                <td>{row.mobile_number}</td>
                <td>{row.vehicle_number}</td>
                <td>{row.vehicle_type}</td>
                <td>{row.distributor_name ?? '-'}</td>
                <td>{row.is_available ? 'Yes' : 'No'}</td>
                <td>
                  <span className={row.is_blocked ? 'badge badge-suspended' : 'badge badge-approved'}>
                    {row.is_blocked ? 'Blocked' : 'Active'}
                  </span>
                </td>
                <td>
                  {row.is_blocked ? (
                    <button type="button" className="btn-sm green" onClick={() => handleUnblock(row.id)}>Unblock</button>
                  ) : (
                    <button type="button" className="btn-sm red" onClick={() => handleBlock(row.id)}>Block</button>
                  )}
                </td>
                <td>{formatDate(row.created_at)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Drivers;
